(function($) {

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    function mfpClose() {
        $.magnificPopup.close();
    }

    $('.js-mfp-close').on('click', function(e) {
        e.preventDefault();
        mfpClose();
    });

    new MiniLazyload({
        // settings
    }, '.lazyload', MiniLazyload.IGNORE_NATIVE_LAZYLOAD);

    // IMG REPLACE TO SVG ELEMENT
    $('img.svg').each(function(){
        var $img = $(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');

        $.get(imgURL, function(data) {
            // Get the SVG tag, ignore the rest
            var $svg = $(data).find('svg');

            // Add replaced image's ID to the new SVG
            if(typeof imgID !== 'undefined') {
                $svg = $svg.attr('id', imgID);
            }
            // Add replaced image's classes to the new SVG
            if(typeof imgClass !== 'undefined') {
                $svg = $svg.attr('class', imgClass+' replaced-svg');
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a');

            // Replace image with new SVG
            $img.replaceWith($svg);

        }, 'xml');
    });

    $('section.text table').wrap("<div class='table-wrap'></div>");

    $(document).ready(function () {

        $('.js-product-gallery').magnificPopup({
            callbacks: {
                elementParse: function(item) {
                    if ( item.el.hasClass('video') )
                        item.type = 'iframe';
                    else
                        item.type = 'image';
                }
            },
            delegate: 'a',
            type: 'image',
            mainClass: 'mfp-img-mobile',
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                preload: [0,1],
            },
        });

        const homepageSlider = $('.js-homepage-slider');

        if ( homepageSlider.length ) {

            homepageSlider.slick({
                autoplay: true,
                autoplaySpeed: 4000,
                dots: true,
                arrows: true,
                prevArrow:'<button type="button" class="slick-arrow left"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg></button>',
                nextArrow:'<button type="button" class="slick-arrow right"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg></button>',
                appendArrows: $('.js-slider-arrows'),
                appendDots: $('.js-slider-dots'),
                customPaging : function () {
                    return '';
                },
                responsive: [
                    {
                        breakpoint: 575,
                        settings: {
                            arrows: false
                        }
                    }
                ]
            });
        }

        $( '<p id="new_text" style="text-align:center; margin-bottom: 7px;" >'+translations.cookies_podnadpis+'</p>', ).insertAfter( "#c-txt" );

        $('.js-tab-item').click(function (e) {
            e.preventDefault();
            $(this).addClass('active').siblings().removeClass('active');
            $('.tabs-content-container .tab-content').eq($(this).index()).show().siblings().hide();
        })

        $('.tabs-content-container .tab-content').hide().first().show();

        const cartListingProducts = $('.js-cart-listing-products');

        if ( cartListingProducts.length ) {

            // if ( $(window).width() < 991 ) {

                cartListingProducts.find('.listing-row').slick({
                    autoplay: true,
                    arrows: true,
                    dots: false,
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    variableWidth: false,
                    pauseOnHover: false,
                    prevArrow:'<button type="button" class="slick-arrow left"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg></button>',
                    nextArrow:'<button type="button" class="slick-arrow right"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg></button>',
                    appendArrows: $('.js-arrows'),
                    responsive: [
                        {
                            breakpoint: 1199,
                            settings: {
                                slidesToShow: 4
                            }
                        },
                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 3
                            }
                        },
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 2
                            }
                        }
                    ]
                })
            // }
        }

        // $('.js-add-to-cart').click(function (e) {
        //     e.preventDefault();
        // }).magnificPopup({
        //     type: 'inline',
        //     preloader: false,
        // });

        // Magnific tits
        $('.js-review-form').magnificPopup({
            type: 'inline',
            preloader: false,
        });

        const deliveryStep1Popup = $('#deliveryStep1Popup')
        if (deliveryStep1Popup.length) {

            $.magnificPopup.open({
                items: {
                    src: deliveryStep1Popup, // ID elementu, ktorý chcete zobraziť
                },
                type: 'inline', // Typ obsahu
                // callbacks: {}
            });

            $('.js-delivery-popup-yes').on('click', function (e) {
                e.preventDefault()
                mfpClose()

                setTimeout( function() {
                    $.magnificPopup.open({
                        items: {
                            src: '#deliveryStep2Popup', // ID elementu, ktorý chcete zobraziť
                        },
                        type: 'inline', // Typ obsahu
                        // callbacks: {}
                    })
                }, 100)
            })
        }

        setTimeout( function () {
            $('.modal-review-form .rating svg').mouseenter( function() {
                $(this).parent().addClass('hovered');
                var rating = $(this).index() + 1;
                for (var i = 0; i<rating; i++) {
                    $('.modal-review-form .rating svg').eq(i).addClass('active');
                }
            })

            $('.modal-review-form .rating svg').mouseleave( function() {
                $(this).parent().removeClass('hovered');
                $('.modal-review-form .rating svg').removeClass('active');
            })

            $('.modal-review-form  .rating svg').click(function () {
                $('.modal-review-form  .rating svg').removeClass('selected');
                var rating = $(this).index() + 1;
                for (var i = 0; i<rating; i++) {
                    $('.modal-review-form  .rating svg').eq(i).addClass('selected');
                }
                $('#rating-input').val(rating);
            });
        }, 2000);

        $('.js-show-login').click(function (e) {
            e.preventDefault();
            $('.login-form').stop().fadeToggle(200);
        })

        $('.js-responsive-button').click(function (e) {
            e.preventDefault();
            $(this).toggleClass('open');
            $('nav.menu').fadeToggle(200);
        })

        $('.js-show-zip').click(function (e) {
            e.preventDefault();
            $('.js-zip-form').fadeToggle(200);
        })

        $('.js-zip-form').click(function (e) {
            e.stopPropagation();
        })

        // if (screen.width > 991) {
        //     $('.js-show-zip').find('.js-zip-form').show();
        // }

        $('.js-close-zip').click(function (e) {
            e.preventDefault();
            $('.js-zip-form').fadeOut(200);
        })

        let pricesPackages;
        let dataPackages;
        if ($('.js-main-price-package').length) {
            pricesPackages = $('.js-main-price-package').attr('data-prices');
            dataPackages = JSON.parse(pricesPackages);
        }

        let pricesPalettes;
        let dataPalettes;
        if ($('.js-main-price-palette').length) {
            pricesPalettes = $('.js-main-price-palette').attr('data-prices');
            dataPalettes = JSON.parse(pricesPalettes);
        }

        // let pricesPalette;
        // let dataPalette;
        // if ($('.js-main-price-palette').length) {
        //     pricesPalette = $('.js-main-price-palette').attr('data-prices');
        //     dataPalette = JSON.parse(pricesPalette);
        //     recalculatePrices();
        // }

        if ($('.js-main-price-package').length || $('.js-main-price-palette').length) {
            recalculatePrices();
        }

        function recalculatePrices() {
            if ($('.calculator').length && $('.js-main-price-package').length) {
                let countPackages = $('.js-count-package').val();
                if (countPackages != '') {
                    let pricePackages;
                    countPackages = parseInt(countPackages);
                    $.each(dataPackages, function (key, val) {
                        let index = key;
                        if (countPackages >= index) {
                            pricePackages = val;
                        }
                    });
                    $('.js-main-price-package').attr('data-price', pricePackages);
                    $('.js-main-price-package').text(pricePackages.replace('.', ',') + ' ' + $('.js-main-price-package').attr('data-currency'));
                    pricePackage = $('.js-main-price-package').attr('data-price');
                    let countPackage = $('.js-count-package').val();
                    let resultPackage;
                    resultPackage = pricePackage * countPackage;
                    resultPackage = Math.round((resultPackage + Number.EPSILON) * 100) / 100;
                    resultPackage = parseFloat(resultPackage).toFixed(2);
                    $('.js-calculated-price-package').text(resultPackage);
                }
            }

            if ($('.calculator').length && $('.js-main-price-palette').length) {
                let countPalettes = $('.js-count-palette').val();
                let main_price_palette = $('.js-main-price-palette');

                if (countPalettes != '') {
                    let pricePalettes;
                    countPalettes = parseInt(countPalettes);
                    $.each(dataPalettes, function (key, val) {
                        let index = key;
                        if (countPalettes >= index) {
                            pricePalettes = val;
                        }
                    });
                    main_price_palette.attr('data-price', pricePalettes);
                    main_price_palette.text(pricePalettes.replace('.', ',') + ' ' + main_price_palette.attr('data-currency'));
                    pricePalette = main_price_palette.attr('data-price');
                    let countPalette = $('.js-count-palette').val();
                    let resultPalette;
                    resultPalette = pricePalette * countPalette;
                    resultPalette = parseFloat(resultPalette).toFixed(2);
                    $('.js-calculated-price-palette').text(resultPalette);

                    if($('.js-calc-text-root').length){
                        let base_price = parseFloat(main_price_palette.attr('data-base-price'));
                        let count_palletes = parseInt(main_price_palette.attr('data-palletes-incart'));
                        let saved = (base_price * (count_palletes + parseInt(countPalette))) - (pricePalette * (count_palletes + parseInt(countPalette)));
                        $('.js-calc-text-saved-sum-2').text(saved.toFixed(2));

                        if(count_palletes < 1 && countPalette > 1 && saved){
                            $('.js-calc-text-saved-2').show();
                            // $('.js-calc-text-saved').show();
                        }
                        else if(count_palletes < 1 && countPalette == 1){
                            $('.js-calc-text-saved-2').hide();
                        }
                    }
                }
            }

                // let countPalette = $('.js-count-palette').val() ;
                // if ( countPalette != '') {
                //     let pricePalette;
                //     countPalette = parseInt(countPalette);
                //     $.each( dataPalette, function( key, val ) {
                //         let index = key;
                //         if (countPalette >= index) {
                //             pricePalette = val;
                //         }
                //     });
                //     $('.js-main-price-palette').attr('data-price', pricePalette);
                //     $('.js-main-price-palette').text( pricePalette.replace('.', ',') + ' €');
                // }
        }

        $('.js-count-package').on('input',function () {
            let min = parseInt( $(this).attr('min') );
            let max = parseInt( $(this).attr('max') );
            let val = parseInt( $(this).val() );
            if (val < min) {
                $(this).val(min);
            }
            if (val > max) {
                $(this).val(max);
            }
            recalculatePrices();
        });

        $('.js-count-palette').on('input',function () {
            let min = parseInt( $(this).attr('min') );
            let max = parseInt( $(this).attr('max') );
            let val = parseInt( $(this).val() );
            if (val < min) {
                $(this).val(min);
            }
            if (val > max) {
                $(this).val(max);
            }
            recalculatePrices();
        });

        // BEGIN SPINNER CART
        $('.counter-icon.plus').click(function() {
            var input = $(this).prev().find('input');
            let max = parseInt(input.attr('max'));
            if (parseInt(input.val()) < max)
                input.val(parseInt(input.val()) + 1);
            recalculatePrices();
        });

        $('.counter-icon.minus').click(function() {
            var input = $(this).next().find('input');
            let min = parseInt(input.attr('min'));
            if (parseInt(input.val()) > min)
                input.val(parseInt(input.val()) - 1);
            recalculatePrices();
        });

        $('section.cart .spin-button.plus').click(function() {
            var input = $(this).prev();
            let max = input.attr('max');
            if (input.val() < max)
                input.val(parseInt(input.val()) + 1);
        });

        $('section.cart .spin-button.minus').click(function() {
            var input = $(this).next();
            let min = input.attr('min');
            if (input.val() > min)
                input.val(parseInt(input.val()) - 1);
        });

        if (  $('section.cart .delivery-wrapper .js-zip-code').length
             && $('section.cart .delivery-wrapper .js-zip-code').hasClass('is-invalid')
        ) $('section.cart .delivery-wrapper .selectize-control .selectize-input').addClass('is-invalid');

        if (  $('section.cart .invoice-wrapper .js-zip-code').length
            && $('section.cart .invoice-wrapper .js-zip-code').hasClass('is-invalid')
        ) $('section.cart .invoice-wrapper .selectize-control .selectize-input').addClass('is-invalid');

        function lockSelectize(input) {
            input.selectize.lock();
        }

        function unlockSelectize(input) {
            input.selectize.unlock();
        }

        if ( $('#delivery-address').length && $('#delivery-address').is(':checked') ) {
            let deliveryWrapper = $('.delivery-wrapper');

            if ( !deliveryWrapper.find('.js-zip-code').hasClass('js-mode-1') )
                lockSelectize(deliveryWrapper.find('.js-zip-code')[0]);
        }

        $('#delivery-address').change(function () {
            let invoiceWrapper  = $('.invoice-wrapper'),
                deliveryWrapper = $('.delivery-wrapper');

            if ($(this).is(':checked')) {
                invoiceWrapper.hide();

                if ( !deliveryWrapper.find('.js-zip-code').hasClass('js-mode-1') ) {
                    deliveryWrapper.find('.js-zip-code').addClass('disabled');
                    lockSelectize(deliveryWrapper.find('.js-zip-code')[0]);
                    invoiceWrapper.find('.js-zip-code').removeClass('disabled');
                }
            }
            else {
                invoiceWrapper.show();

                if ( !deliveryWrapper.find('.js-zip-code').hasClass('js-mode-1') ) {
                    deliveryWrapper.find('.js-zip-code').removeClass('disabled');
                    unlockSelectize(deliveryWrapper.find('.js-zip-code')[0]);

                    if ( invoiceWrapper.find('.js-zip-code').val().length > 0 )
                        invoiceWrapper.find('.js-zip-code').addClass('disabled');
                        lockSelectize(invoiceWrapper.find('.js-zip-code')[0]);
                }
            }
        })
    });

    $("*").on("touchstart",function(){
        $(this).trigger("hover")}).on("touchend",function(){
        $(this).trigger("hover")
    });

    $('.js-orders-list .item .title').click(function (e) {
        e.preventDefault();
        $(this).next().stop().slideToggle(200);
    });

    $('section.dropdowns dt').click(function (e) {
        e.preventDefault();
        $(this).next().stop().slideToggle(200);
    });

    $('.shop-tabs').hide().first().show();

    function universal_ajax(url){

        $.ajax({
            url: url,
            method: 'POST',
        }).done(function(value) {
            return value;
        }).fail(function(content) {
            console.log(content);
        });
    }

    function renderShops(shop_id, language_id = 1) {
        $('.loading').show();

        $.ajax({
            url: $('.js-render-shops').attr('data-url'),
            data: { shop: shop_id, language_id: language_id },
            method: 'POST',
        }).done(function(content) {

            $('.js-render-shops').html(content);
            $('.loading').hide();
        }).fail(function(content) {
            console.log(content);
        });
    }

    if ( $('.js-render-shops').length ) {
        $(document).on('change', '.js-shop-select', function() {
            renderShops( $(this).val(), $(this).attr('data-language-id') );

            if ( !$('.infoWindow').hasClass() )
                $('.infoWindow').addClass('active');

            var html = '<div class="infoWindowHTML">';
            html = html + $('#' + $('.infoWindowHTML [data-shop="'+$(this).val()+'"]').closest('.infoWindowHTML').attr('id')).html();
            html = html + '</div>';

            $('.infoWindow .content').html(html);
        });

        $(document).on('click', '.js-show-prices', function(e) {
            e.preventDefault();
            renderShops( $('.js-show-prices').attr('data-shop'), universal_ajax($('.js-show-prices').attr('data-route-shop')) );

            $('html,body').animate({
                scrollTop: $('.js-shop-select').offset().top
            }, 800);
        });

        renderShops( $('.js-render-shops').attr('data-shop'), $('.js-render-shops').attr('data-language-id') );
    }

    $(document).on('click', '.js-shop-categories a', function(e) {
        e.preventDefault();
        let $target = $(this).attr('href').replace('#', '');
        let section = $(this).closest('section').next();
        $('html,body').animate({
            scrollTop: section.find( ".shop-list[data-category="+$target+"]" ).offset().top
        }, 200);
    });

    $('.js-zip-code').selectize({
        delimiter: ',',
        persist: false,
        valueField: 'id',
        searchField: ['zip', 'city'],
        labelField: 'zip',
        maxItems: 1,
        maxOptions: 50,
        loadingClass: 'loading-selectize',
        //openOnFocus: false,
        onChange: function(value) {
            let self = this.$input;

            // Select, ktorý je v prvom kroku košíka to jest ak má setnuté shop_id
            if ( self.siblings('.js-selectize-shop-id').length && self.siblings('.js-selectize-shop-id').val().length > 0 ){

                $('.js-cart1-step-form').find('.js-delivery').val(value);
            }

            if ( $('section.cart .delivery-wrapper').length && $('section.cart .invoice-wrapper').length ) {

                if ( value.length ) {

                    $.ajax({
                        url: '/nastavenie/vrat-mesto',
                        type: 'Post',
                        dataType: 'json',
                        data: { id: value },
                        error: function(err) {
                            console.log(err);
                        },
                        success: function(res) {
                            self.parent().parent().parent().find('.js-city').val(res.city);
                        }
                    });
                }
            }
        },
        onItemAdd: function (value, $item){
            if($item.closest('form').find('.js-zip-code-cart1').length){
                setTimeout(function(){
                    $item.closest('form').submit();
                }, 100);
            }
        },
        render: {
            option: function(item, escape) {

                let text = escape(item.zip);

                if(item.city){
                    text = text + ', '+  escape(item.city)
                }

                if(item.city != item.part){
                    text = text + ' (' + item.part + ')';
                }

                return '<div>' + text + '</div>';
            },
            item: function(item, escape) {

                let text = escape(item.zip);

                if(item.city && item.city !== 'undefined'){
                    text = text + ', '+  escape(item.city)
                }

                if(item.city && item.city !== 'undefined' &&  item.city != item.part ){
                    text = text + ' (' + escape(item.part) + ')';
                }

                return '<div>' + text + '</div>';
            },
        },
        load: function(query, callback) {

            if ( !query.length ) return callback();

            $.ajax({
                url: '/kereses/get-places',
                type: 'GET',
                dataType: 'json',
                data: { s: query, shop_id: this.$input.siblings('.js-selectize-shop-id').val() },
                error: function() {
                    callback();
                },
                success: function(res) {
                    callback(res.data);
                }
            });
        },
    });

    let btnCookie = $('.js-cookie-accept');

    btnCookie.on('click', function () {
        $('.cookie-consent').removeClass('cookies-show');
        setCookie('cookie-accepted','true',30);
    });

    setTimeout(function() {
        let x = getCookie('cookie-accepted');
        if (!x)
            $('.cookie-consent').addClass('cookies-show');
    }, 1000);

    // document.addEventListener('touchstart', onTouchStart, {passive: true});

    moveHeaderFromTop();


})(jQuery);

$(window).resize(function () {

    moveHeaderFromTop();
});

/* COOKIE FUNCTIONS */
function setCookie(name, value, days) {
    let expires = '';

    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }

    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
    let nameEQ = name + "=",
        ca     = document.cookie.split(';');

    for ( let i = 0; i < ca.length; i++ ) {
        let c = ca[i];
        while ( c.charAt(0) == ' ' ) c = c.substring(1, c.length);
        if ( c.indexOf(nameEQ) == 0 ) return c.substring(nameEQ.length, c.length);
    }

    return null;
}

function eraseCookie(name) {
    setCookie(name,'',-1);
}

function moveHeaderFromTop() {
    if($('.js-warn-info').length){
        $('header').css('margin-top', $('.js-warn-info').height());
    }
}
